import BaseModel from "./BaseModel";
import moment from "moment";
import roundFloat from "../Helpers/Misc/roundFloat";

class CommentAttachment extends BaseModel {
	constructor(data, attachToComment = null) {
		super({}, CommentAttachment.defaults);
		this.data = data;

		this._url = "";

		this.comment = attachToComment;
	}

	isNew() {
		return (typeof this.id === "undefined") || this.id === -1;
	}

	get id() {
		return this.get("id");
	}

	get fileName() {
		return this.get("file_name");
	}

	get materialIcon() {
		if (this.isImage()) {
			return "image";
		}
		return "description";
	}

	isImage() {
		return (["png", "jpg", "gif", "bmp"].indexOf(this.fileType) >= 0);
	}

	get fileType() {
		return this.get("file_type");
	}

	get fileSize() {
		return this.get("size_bytes");
	}

	get userId() {
		return this.get("user_id");
	}

	get readableFileSize() {
		if (this.fileSize < 1024) {
			return this.fileSize + " bytes";
		}
		else if (this.fileSize < 1024 * 1024) {
			return Math.floor(this.fileSize / 1024.0) + " kilobytes";
		}
		// else if (this.fileSize < 1024 * 1024 * 1024) {
		return roundFloat(this.fileSize / (1024.0 * 1024), 1) + " megabytes";
		// }
	}

	get timestamp() {
		return this.get("timestamp");
	}

	get relativeTime() {
		return moment(this.timestamp * 1000).fromNow();
	}

	get fullTimestamp() {
		return moment(this.timestamp * 1000).format("MMM Do YYYY HH:mm A");
	}

	set url(s) {
		this._url = s;
	}

	get url() {
		return this._url;
	}

	update(data) {
		super.setData(data);
	}
}
CommentAttachment.defaults = { // Defaults
	id: -1,
	comment_id: -1,
	user_id: -1,
	file_name: "default.file",
	file_type: "file",
	size_bytes: -1,
	timestamp: 0,
	removed: 0
};

export default CommentAttachment;
